import { API_ADMIN_URL } from "../../config/constants";
import { postRequest } from '../API'

/*********************************************************
* Function Name : List
* Description   : 
* By            : Afsar Ali
* Date          : 05-06-2025
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}common/general-data`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : List
* Description   : 
* By            : Afsar Ali
* Date          : 05-06-2025
*********************************************************/
export const updateGeneralData = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}common/update-general-data`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : getBas264Image
* Description   : 
* By            : Afsar Ali
* Date          : 05-06-2025
*********************************************************/
export const getBas264Image = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}common/proxy-image`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return res?.data?.response?.image;
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

